import {
  playLaborIdleWarningSound,
  playPairFailureSound,
  playPairSuccessSound,
} from "@/lib/floorStationPairAudio";

export type ClampQcInspectionResultLabel = "Passed" | "Failed";

/** Pass + saved: success chime. Fail + saved: caution triangles. API error: square error beeps. */
export function playClampQcInspectionCompleteSound(result: ClampQcInspectionResultLabel): void {
  if (result === "Passed") {
    playPairSuccessSound();
    return;
  }
  playLaborIdleWarningSound();
}

export function playClampQcInspectionSubmitErrorSound(): void {
  playPairFailureSound();
}
